import * as React from 'react';
export const signalSvg = React.forwardRef(function signalSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      d: 'M1.2 10.5V7.75a.8.8 0 1 1 1.6 0v2.75a.8.8 0 1 1-1.6 0Zm5.6 0V4.75a.8.8 0 1 0-1.6 0v5.75a.8.8 0 1 0 1.6 0Zm2.4 0v-9a.8.8 0 1 1 1.6 0v9a.8.8 0 1 1-1.6 0Z',
    }),
  );
});
signalSvg.defaultProps = {
  width: '12',
  height: '12',
  viewBox: '0 0 12 12',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var signal = {
  category: 'icon',
  colorable: true,
  name: 'signal',
  svg: signalSvg,
};
